export type AgeBracket = 'infant' | 'toddler' | 'child' | 'teen' | 'adult';

export function getAgeBracket(age: number): AgeBracket {
  if (age === 0) return 'infant';
  if (age <= 2) return 'toddler';
  if (age <= 12) return 'child';
  if (age <= 17) return 'teen';
  return 'adult';
}
